import axios from 'axios'

export default {
    namespaced: true,
    state: {
        hotels: []
    },
    getters: {
        GET_SELECT_LIST(state) {
            return state.hotels.map((item) => {
                if ('text' in item) {
                    return item
                } else {
                    return {name: item.name, id: item.id}
                }
            })
        }
    },
    mutations: {
        CLEAR_DATA(state) {
            state.hotels = []
        },
        FETCH_HOTELS(state, hotels) {
            state.hotels = hotels
        },
        ADD_HOTELS(state, hotel) {
            state.hotels.push(hotel)
        },
        EDIT_HOTELS(state, payload) {
            const index = state.hotels.findIndex(
                item => item.id === payload.id
            )
            if (index !== -1) {
                Object.assign(state.hotels[index], payload.data)
            }
        },
        DEL_HOTELS(state, hotel) {
            const index = state.hotels.findIndex(
                item => item.id === hotel.id
            )
            if (index !== -1) {
                state.hotels.splice(index, 1)
            }
        },
    },
    actions: {
        fetch({commit, dispatch, state}, payload={}) {
            return new Promise((resolve, reject) => {
                if (state.hotels.length) {
                    resolve(state.hotels)
                } else {
                    axios.post(
                        '/api/root/hotels/list',
                        {hotel_chain_id: payload.hotel_chain_id}
                    ).then(({data}) => {
                        commit('FETCH_HOTELS', data.data)
                        resolve(data.data)
                    }).catch((error) => {
                        dispatch('checkUnauthenticated', error, { root: true })
                        reject(error)
                    })
                }
            })
        },
        add({dispatch, commit}, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/root/hotels/add',
                    data
                ).then(({data}) => {
                    commit('ADD_HOTELS', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        edit({dispatch, commit}, payload) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/root/hotels/edit/' + payload.currentId,
                    payload.editedItem
                ).then(({data}) => {
                    commit('EDIT_HOTELS', {data: data.data, id: payload.currentId})
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({dispatch, commit}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/root/hotels/dell/' + itemId
                ).then(({data}) => {
                    commit('DEL_HOTELS', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        clear({commit}) {
            commit('CLEAR_DATA')
        }
    }
}

